var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 226.612,
    height: 84.531,
    viewBox: "0 0 226.612 84.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 211.612,
    height: 72.03,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66b0fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9866fe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6",
    x: 0,
    y: 29.156,
    width: 55.375,
    height: 55.375,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#66b0fe",
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe49f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe4974"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7",
    x: 40.375,
    y: 29.156,
    width: 55.375,
    height: 55.375,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fe49f6",
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2fe17"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8",
    x: 80.749,
    y: 29.156,
    width: 55.375,
    height: 55.375,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fee117",
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16cf6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16b6cf"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_9",
    x: 121.124,
    y: 29.156,
    width: 55.375,
    height: 55.375,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#16cf6b",
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x2: 0.634,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedf18"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_1",
    x: 161.499,
    y: 29.156,
    width: 65.113,
    height: 55.375,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fe9e18",
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2",
    x: 12.871,
    y: 34.924,
    width: 33.633,
    height: 37.803,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_3",
    x: 52.836,
    y: 34.924,
    width: 34.453,
    height: 37.803,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_4",
    x: 90.646,
    y: 34.924,
    width: 39.581,
    height: 37.803,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_5",
    x: 132.166,
    y: 34.548,
    width: 37.291,
    height: 38.59,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6",
    x: 173.379,
    y: 34.925,
    width: 35.615,
    height: 37.803,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M.676-8.658C.676-3.38,4.654.312,9.958.312s9.256-3.692,9.256-8.97-3.952-8.97-9.256-8.97S.676-13.936.676-8.658Zm13.988,0A4.688,4.688,0,0,1,9.958-3.64,4.693,4.693,0,0,1,5.226-8.658a4.679,4.679,0,0,1,4.732-5.018C12.818-13.676,14.664-11.492,14.664-8.658ZM33.28,0H37.6V-17.342H33.1v9.984l-7.02-9.984h-4.6V0h4.472V-10.478ZM51.246,0h4.472V-13.442h4.836v-3.9H46.384v3.9h4.862ZM74.36,0h4.472V-17.342H74.36v6.474h-7.2v-6.474H62.686V0h4.472V-6.968h7.2Zm7.592,0H94.666V-3.77H86.424V-6.89h8.06v-3.8h-8.06v-2.886h8.242v-3.77H81.952Zm31.642,0h5.122L115.18-6.37a5.254,5.254,0,0,0,3.458-5.2c0-3.224-2.184-5.772-6.032-5.772h-8.684V0h4.472V-5.876h2.288Zm.494-11.622a2,2,0,0,1-2.158,1.95h-3.536v-3.9h3.536A2,2,0,0,1,114.088-11.622ZM121.108,0h4.472V-17.342h-4.472Zm6.708-8.658c0,5.512,4.212,8.97,9.386,8.97a10.019,10.019,0,0,0,7.67-3.38V-9.854H136.5v3.718h3.978V-4.68A5.4,5.4,0,0,1,137.2-3.64a4.791,4.791,0,0,1-4.836-5.018,4.791,4.791,0,0,1,4.836-5.018,4.309,4.309,0,0,1,3.666,2.054l3.744-1.976a8.157,8.157,0,0,0-7.41-4.03C132.028-17.628,127.816-14.17,127.816-8.658ZM159.172,0h4.472V-17.342h-4.472v6.474h-7.2v-6.474H147.5V0h4.472V-6.968h7.2Zm11.466,0h4.472V-13.442h4.836v-3.9h-14.17v3.9h4.862Z",
    transform: "translate(0 24.466)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Rectangle_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-2",
    "data-name": "Rectangle 6",
    width: 40.375,
    height: 40.375,
    transform: "translate(7.5 31.66)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Rectangle_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-2",
    "data-name": "Rectangle 7",
    width: 40.375,
    height: 40.375,
    transform: "translate(47.87 31.66)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Rectangle_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8-2",
    "data-name": "Rectangle 8",
    width: 40.375,
    height: 40.375,
    transform: "translate(88.25 31.66)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Rectangle_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9-2",
    "data-name": "Rectangle 9",
    width: 40.375,
    height: 40.375,
    transform: "translate(128.62 31.66)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Path_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M332,65.076v40.375h33.4l16.714-20.187L365.4,65.076Z",
    transform: "translate(-163 -33.42)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Path_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M28.741,88.23H22.348V83.1H40.98V88.23H34.621v17.675h-5.88Z",
    transform: "translate(-3.98 -42.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Path_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    "data-name": "Path 3",
    d: "M113.394,98.179h-3.009v7.727H104.5V83.1h11.419c5.06,0,7.932,3.351,7.932,7.59a6.909,6.909,0,0,1-4.547,6.837l4.65,8.376h-6.735Zm1.641-10.119h-4.65v5.128h4.65a2.577,2.577,0,1,0,0-5.128",
    transform: "translate(-46.17 -42.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Path_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4-2",
    "data-name": "Path 4",
    d: "M199.259,102.452h-9.471l-1.162,3.453h-6.393l8.581-22.8H198.2l8.616,22.8h-6.393Zm-7.932-4.957h6.393l-3.214-9.265Z",
    transform: "translate(-86.09 -42.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Path_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    d: "M267.588,94.123c0-7.043,5.333-11.8,12.171-11.8a10.6,10.6,0,0,1,10.119,6.12l-5.06,2.393a5.532,5.532,0,0,0-5.06-3.316,6.612,6.612,0,0,0,0,13.2,5.532,5.532,0,0,0,5.06-3.316l5.06,2.393a10.671,10.671,0,0,1-10.119,6.119c-6.838,0-12.171-4.786-12.171-11.795",
    transform: "translate(-129.92 -42.28)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, 0)",
    filter: "url(#Path_6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    d: "M359.729,97.325l-1.539,1.915v6.667h-5.88V83.1h5.88V92.47L365.2,83.1h7.248l-8.855,10.666,9.333,12.137h-7.213Z",
    transform: "translate(-173.43 -42.68)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.33bb92873632b6cb19c1c0cdf7a33c36.svg";
export { ForwardRef as ReactComponent };